<template>
  <div>
    <v-row class="col-12 pa-0 ml-0">
      <div class="col-12 pa-0">
        <v-parallax class="ok" height="450"  src="@/assets/parallax/transformador1.jpg">
          <h1 class="text-center display-2 font-weight-medium py-5">Comerzializadora, Servicios especializados <br/> INCLAN S.A de C.V</h1>
          <div class="text-center">
              <v-btn
                depressed
                color="primary"
                class="text-initial"
              >
                Contáctanos
              </v-btn>
          </div>
        </v-parallax>
      </div>
        <div class="col-12 pa-6 gray blue lighten-5 py-0 text-center">
          <div class="py-9">
            <h1 class="py-5">Somos una empresa LIDER </h1>
          <p class="headline">Con mas de 12 años realizando mantenimiento a transformaderes y lineas de alta tensíon</p>
          </div>
        </div>
        <div class="col-12 pa-6 grey lighten-4     py-0 text-center">
          <v-container class="py-9">
            <h1 class="">Servicios </h1>
          <p class="headline">Servicios  que ofrecemos</p>
          <div class="row col-12 pa-4 ma-0" style="height: 100%;">
            <v-col v-for="service in services" :key="service.id" cols="12" lg="3" md="3" >
          <v-card class="mx-auto elevation-0"  style="height: 100%; max-height: 100%;">
            <v-img height="250" :src="service.ulr" ></v-img>
            <p 
              class="mb-0 title text-initial font-weight-regular indigo--text darken-3 text-center py-4 pa-2">
             {{service.name}}
            </p>
          </v-card>
        </v-col>
          </div>
          <div class="text-center">
              <v-btn
                depressed
                color="primary"
                class="text-initial"
              >
                Ver más servicios
              </v-btn>
          </div>
          </v-container>
        </div>
    </v-row>
  </div>
</template>

<script>
  export default {
    name: 'HomeView',
    data: () => ({
      services:[
        {
          name: 'Mantenimiento predictivo, preventivo y correctivo a subestaciones electricas en alta y baja tensión',
          ulr: 'https://www.ipvsl.com/wp-content/uploads/2019/02/IPV-Not_Febrer_19.png'
        },
        {
          name: 'Mantenimiento predictivo, preventivo y correctivo a motores electricos industriales',
          ulr: 'https://www.mcb.com.mx/wp-content/uploads/2024/03/mante-industrial.jpg'
        },
        {
          name: 'Instalaciones electricas industriales',
          ulr: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTIEN2WnEuAnbgPcTDWvTB5Cg5HAZ0iIdMthA&s'
        },
        {
          name: 'Proyectos electricos',
          ulr: 'https://altertecnia.com/wp-content/uploads/ingenieria-de-proyectos-industriales.jpg'
        }
      ]
  }),
   
  
  }
</script>
